const testimonials = [
  {
    name: "Kelly R.",
    location: "Cocoa Beach, FL",
    rating: 5,
    text: "I've been surfing Cocoa Beach since I was a kid and chasing swells in Costa Rica for the last five years. Got a call from a buddy about an overhead swell hitting Tamarindo in ten days. Checked my passport and it had expired three months ago while I was working and not traveling. Fast Passport Center got my renewal done in four business days. Caught the swell, scored epic waves at Playa Grande, and didn't miss a single session. Lifesaving service for surfers.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "Amanda T.",
    location: "Cape Canaveral, FL",
    rating: 5,
    text: "We booked a last-minute Disney cruise out of Port Canaveral for our daughter's birthday — three cabins, extended family, the whole thing. Five days before sailing, we realized my husband's passport had expired during COVID when we weren't traveling. We were panicked. Fast Passport Center expedited his renewal and we had it back in three business days. Made the cruise, my daughter met every princess on the ship, and our family vacation was saved.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Mark D.",
    location: "Merritt Island, FL",
    rating: 5,
    text: "I'm a launch photographer covering SpaceX missions from the Cape. Got credentialed for an Ariane 6 launch in French Guiana with eight days' notice — a career opportunity I couldn't pass up. My passport was valid but had less than three months remaining, and French Guiana requires six months. Fast Passport Center expedited my renewal in three business days. Made the launch, got the shots, portfolio expanded. I've been recommending this service to every photographer on the Space Coast.",
    service: "Expedited Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CocoaBeachTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Cocoa Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Cocoa Beach surfers, cruise families, launch photographers, and beachside residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}